"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import { FlowActions } from "../../stores/flowStore";
/**
 * Launch the list Item flow given the array of item objects
 * @param items - An array of items to list.
 * @returns object
 *  - listItems: function that launches the list item flow
 */
export const useCreateListingsFlow = t0 => {
  const $ = _c(4);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    mode: t2
  } = t1;
  const mode = t2 === undefined ? "full" : t2;
  let t3;
  if ($[2] !== mode) {
    t3 = items => {
      const allSameChain = items.every(item => item.chain.identifier === items[0].chain.identifier);
      if (!allSameChain) {
        throw new Error("All items for listItems call must all be from the same chain.");
      }
      FlowActions.startFlow({
        type: "listing",
        items,
        mode
      });
    };
    $[2] = mode;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};